import {getUserConfig} from "@utility/utils";

const initialState = {
    list: [],
    total: 0,
    loading: false,
    submitting: false,
    searchParams: {
        refresh: false,
        status_tag: "",
        operatorID: "",
        start_date: "",
        end_date: "",
        page: 1,
        count: 30,
        ...getUserConfig("urgentData")
    }
}

const urgent = (state = initialState, action) => {
    switch (action.type) {
        case 'URGENT_DATA':
            return {
                ...state,
                ...action.payload
            }
        case 'URGENT_DATA_RELOAD':
            return {
                ...state,
                searchParams: {
                    ...state.searchParams,
                    refresh: true
                }
            }
        case 'URGENT_DATA_INIT':
            return {
                ...initialState,
                searchParams: {
                    ...initialState.searchParams,
                    ...getUserConfig("urgentData")
                }
            }
        default:
            return {...state};
    }
}

export default urgent
